<div id="banner-funds-depositos" class="swiper-background d-lg-flex align-items-center pt-5 pt-lg-0">
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div class="col-12 col-lg-8">
        <div class="img-container mb-3">
          <img src="/assets/images/funds/myInvestor/FUNDS+MYI.svg" alt="MyInvestor | SEGO Funds" title="MyInvestor | SEGO Funds" class="img-fluid logo-myinvestor">
        </div>
        @if (!isLoading) {
        <h1 class="h1-display primary-900 mb-2">¡Depósitos al
          <span class="secondary-funds-700">{{datosDeposito?.tae3MesesAutomatizada | decimalFormat:
            'two-decimals'}}% TAE <br class="title-breakpoint"></span> a 3 meses!
        </h1>
        <div class=" d-none d-lg-block">
          <p class="subtitle-container p-display mb-2">
            Si tienes <strong class="p-display-bold">cartera automatizada</strong> tendrás mejores
            rentabilidades en
            <strong class="p-display-bold">depósitos a 3, 6 y 12 meses. ¡Descúbrelos!</strong>
          </p>
        </div>
        <p class="p1-regular primary-900 d-none d-lg-block">Sólo hasta el
          <strong class="p1-bold">{{datosDeposito?.fechaLimite}}</strong>
        </p>
        }
        <div class="mt-3 mt-lg-4">
          @if (plataformaId !== 'FUNDS') {
            <app-btn-link [linkId]="'btn-banner-depositos'" [linkType]="'href'" [linkTitle]="'Más información'"  [linkTarget]="'_blank'"  [linkUrl]="domainUrl + '/depositos'"></app-btn-link>
          }
          @if (plataformaId === 'FUNDS') {
            <app-btn-link [linkId]="'btn-banner-depositos'" [linkType]="'routerLink'" [linkTitle]="'Más información'"  [linkUrl]="'depositos'"></app-btn-link>
          }
        </div>
      </div>

      <div class="col-12 col-lg-4 contenedor-depositos text-center mt-4 mt-lg-0">
        <img src="/assets/images/funds/depositos/depositos.png" alt="SEGO Funds: Depósitos" title="SEGO Funds: Depósitos" class="img-fluid">
      </div>
    </div>
  </div>
</div>